export default __webpack_public_path__ + "static/media/person_2@3x.4991c779.png";